<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Historial solicitudes de empaques
            <router-link
              :to="{
                name: 'NuevoSolicitudEmpaque',
                params: {
                  config: { page: page, 
                  dates: selectedDate, 
                  }
                }
              }"
            >
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-pencil" />Registrar solicitud de empaques
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="4" lg="4" xl="4">
                <label class="d-block">Periodo:</label>
                <DateSelector
                  class="z-custom-2"
                  v-model="selectedDate"
                  :date="selectedDate"
                  @input="dateSelection()"
                />
              </CCol>
              
            </CRow>
            <br>
            <CDataTable
              hover
              bordered
              responsive
              :loading="isLoading"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #over-table>
                <CRow>
                  
                  <CCol sm="11" col="10">
                    <CInput v-model="filter" @input="searchTimeOut()" placeholder="Búsqueda..." />
                  </CCol>
                  <CCol class="p-0" sm="1" col="2">
                    <CDropdown
                      placement="bottom-start"
                      add-menu-classes="pt-0"
                      color="primary"
                      :show.sync="dropdownCustom"
                    >
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-settings" />
                        </CButton>
                      </template>

                      <template #default>
                        <div class="p-3 d-flex flex-column w-100">
                          <div class="mb-1">
                            <span>
                              <strong>Ver</strong>
                            </span>
                          </div>
                          <hr class="line mt-1 mb-3" />

                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Cancelados:</label>
                            <CSwitch
                              @update:checked="toggleShowCancel()"
                              class="mx-1"
                              color="primary"
                              variant="3d"
                            />
                          </div>
                          <div class="d-flex align-items-center justify-content-between mb-2">
                            <label class="mr-2">Autor:</label>
                            <CSwitch @update:checked="toggleMostrarAutor()" class="mx-1" color="primary" variant="3d" />
                          </div>
                        </div>
                      </template>
                    </CDropdown>
                  </CCol>
                </CRow>
              </template>
              <template #folio-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Folio</span>
                  <OrderButtons :onClick="sortField" :field="'doc_solicitudes_empaques.folio'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #fechahora-header>
                <div class="d-flex flex-row">
                  <span class="align-self-center">Fecha</span>
                  <OrderButtons :onClick="sortField" :field="'doc_solicitudes_empaques.payload->encabezado->fechahora'" :order="false" :fila="actualSort" :direcction="sorting"/>
                </div>
              </template>
              <template #folio="{item}">
                <td class="py-2">{{ item.folio }}</td>
              </template>
              <template #fechahora="{item}">
                <td class="py-2">{{ getDate(item.payload.encabezado.fechahora) }}</td>
              </template>
              <template #estado="{item}">
                <td class="py-2">{{ item.estado }}</td>
              </template>
              <template #ubicacion="{item}">
                <td class="py-2">{{ item.payload.encabezado._relaciones.ubicacion?item.payload.encabezado._relaciones.ubicacion.payload.nombre:'' }}</td>
              </template>
              <template #cultivo="{item}">
                <td class="py-2">{{ item.payload.encabezado.cultivo||'N/A' }}</td>
              </template>
              <template #solicitante="{item}">
                <td class="py-2">{{ item.payload.encabezado.solicitante }}</td>
              </template>
              <template #autorizar="{item, index}">
                <td class="py-2">
                  <CButton
                    v-if="!item.payload.encabezado.autorizada"
                    color="info"
                    square
                    size="sm"
                    @click="()=>toggleAutorizar(index, item)"
                  >Autorizar</CButton>
                </td>
              </template>
              <template #autor-header>
                <div class="d-flex flex-row">
                  <span v-show="mostrarColumnaAutor">Autor</span>
                </div>
              </template>
              <template #autor="{item}">
                <td class="py-2">
                  <span v-show="mostrarColumnaAutor">{{ item.author.correo }}</span>
                </td>
              </template>
              <template #ver="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'VerSolicitudEmpaque',
                      params: {
                        id: item.folio,
                        config: { 
                          page: page, 
                          dates: selectedDate, 
                        }
                      }
                    }"
                  >
                    <CButton color="success" square size="sm">Ver</CButton>
                  </router-link>
                </td>
              </template>
              <template #reporte="{item, index}">
                <td class="py-2">
                  <CButton
                    v-if="!!item.payload.encabezado.autorizada"
                    color="info"
                    square
                    size="sm"
                    @click="getReporte(index, item)"
                  >
                  <i v-if="loader[index]" class="fa fa-spinner fa-pulse"></i>
                  <template v-else>PDF</template>
                  </CButton>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                  >Cancelar</CButton>
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => actualizarInfo(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Cancelar solicitud de empaques"
      color="danger"
    >
      <h5 class="text-center">¿Deseas cancelar la solicitud de empaques con folio {{ this.itemModal.name }}?</h5>
      <template #header>
        <h5 class="modal-title">Cancelar solicitud de empaques</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton @click="cancelDocto(itemModal.index, itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="autorizarModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Autorizar solicitud de empaque"
      color="info"
    >
      <h5 class="text-center">¿Deseas autorizar la solicitud de empaque con folio {{ this.itemModal.name }}?</h5>
      <template #header>
        <h5 class="modal-title">Autorizar solicitud de empaque</h5>
        <CButtonClose @click="autorizarModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="autorizarModal = false" color="danger">Cancelar</CButton>
        <CButton @click="autorizar(itemModal.id)" color="success">Aceptar</CButton>
      </template>
    </CModal>
    <CModal
      size="sm"
      title="Reporte"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>

  </div>
</template>

<script>
import DateSelector from "../../customComponents/DateSelector";
import moment from "moment";
import "vue-select/dist/vue-select.css";
import OrderButtons from "../../customComponents/OrderButtons";
import GridAutorMixin from "../../mixins/GridAutor";

const today = new Date();

const fields = [
  { key: "folio", label: "Folio", _style: "width:10%" },
  // { key: "ubicacion", _style: "width:10%" },
  { key: "fechahora", label: "Fecha", _style: "width:10%" },
  { key: "estado", label: "Estado", _style: "width:10%" },
  { key: "ubicacion", label: "Ubicación", _style: "width:10%" },
  { key: "cultivo", label: "Cultivo", _style: "width:10%" },
  { key: "solicitante", label: "Solicitante", _style: "width:10%" },
  // { key: "producto", label: "Producto", _style: "width:10%" },
  // { key: "unidad", label: "Unidad", _style: "width:10%" },
  // { key: "costo_unitario", label: "Costo Unitario", _style: "width:10%" },
  // { key: "cantidad", label: "Cantidad", _style: "width:10%" },
  // { key: "costo_total", label: "Costo Total", _style: "width:10%" },
  {
    key: "autor",
    label: "",
    _style: "width:1%",
  },
  {
    key: "autorizar",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "ver",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "reporte",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "SolicitudEmpaque",
  mixins: [GridAutorMixin],
  components: {
    DateSelector,
    OrderButtons
  },

  data() {
    return {
      items: [],
      fields,
      warningModal: false,
      error: "",
      config: this.$route.params.config,
      isCreated: false,
      // entradas: [],
      autorizarModal: false,
      filter: "",
      isLoteActive: true,
      dropdownCustom: false,
      showCancel: false,
      color1: "primary",
      color2: "secondary",
      actualSort: "doc_solicitudes_empaques.payload->encabezado->fechahora",
      actualSortJoin: "",
      cambioUbicacionRaiz: false,
      page: 1,
      pages: 1,
      sorting: "desc",
      sortingJoin: "",
      sort: [
        {
          field: "doc_solicitudes_empaques.folio",
          isSorter: true
        },
        {
          field: "doc_solicitudes_empaques.payload->encabezado->fechahora",
          isSorter: true
        }
      ],
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      isLoading: false,
      cancelModal: false,
      itemModal: { id: "", name: "", index: "" },
      selectedDate: {
        start: new Date(today.getFullYear(), today.getMonth(), 1),
        // start: new Date(2019, 1, 1),
        end: new Date(today.getFullYear(), today.getMonth() + 1, 0)
        // end: new Date(2020, 2, 11)
      },
      loader:{},
    };
  },

  created() {
    if (this.ubicacionRaiz == "") {
      this.items = []
      return
    }
    this.isCreated = false;
    this.page = this.config ? this.config.page : 1;
    this.selectedDate = this.config ? this.config.dates : this.selectedDate;
    this.actualizarInfo();
  },

  computed: {
    rangeStart() {
      return new Date(this.selectedDate.start).toLocaleDateString();
    },
    rangeEnd() {
      return new Date(this.selectedDate.end).toLocaleDateString();
    },
    filteredItems() {
      return this.items.filter(
        i =>
          i.folio
            .toString()
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          i.payload.encabezado.folio_proveedor
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          this.getDate(i.payload.encabezado.fechahora)
            .toLowerCase()
            .includes(this.filter.toLowerCase())
      );
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    items(newV,){
      this.loader = newV.reduce((v,c,i)=>({...v,[i]:false}),{})
    },
    ubicacionRaiz: function() {
      if (this.ubicacionRaiz == "") {
        this.items = []
        return
      }
      this.page = 1;
      this.cambioUbicacionRaiz = true
      this.actualizarInfo();
    }
  },

  methods: {
    autorizar(folio){
      this.$store.dispatch("customDocumentoActualizarHTTP", {
                schema: "solicitudes_empaques",
                folio,
                payload: {
                    encabezado: {
                        autorizada: true
                    }
                }
            }).then(() => {
                this.alertSuccess = true
            }).catch(error => {
                this.error = error.message;
                this.warningModal = true;
                this.isLoading = false;
            }).finally(() => {
                this.autorizarModal = false;
                this.isLoading = false;
                this.actualizarInfo();
            });
    },
    getReporte(index,item){
      if(this.loader[index]){
        return
      }
      this.loader[index] = true
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_solicitudes_empaques",
        params: { folio:item.folio, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);

      
        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        }).then(res => {

          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte salidas de empaques.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader[index] = false
          this.$forceUpdate();
        });
    },
    searchTimeOut() {
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.actualizarInfo();
        }, 800);
      }
    },

    toggleShowCancel() {
      // console.log("entro");
      this.showCancel = !this.showCancel;
      this.actualizarInfo();
    },
    toggleAutorizar(index, item) {
      this.autorizarModal = true;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index
      };
      this.itemModal = itemIndex;
    },
    getDate(date) {
      
      return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    sortField(field, direction, join) {
      if (join) {
        this.actualSort = ""
        this.sorting = ""
        this.actualSortJoin = field
        this.sortingJoin = direction
      }else{
        this.actualSort = field
        this.sorting = direction
        this.actualSortJoin = ""
        this.sortingJoin = ""
      }
      this.actualizarInfo();
    },
    getSorted(field) {
      const newSort = this.sort.find(item => item.field == field);
      if (newSort) {
        return newSort.isSorter;
      }
      return false;
    },
    dateSelection() {
      
      if (this.isCreated) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          // console.log("funciona");
          this.actualizarInfo();
        }, 800);
      }
    },
    toggleEdit(index, item) {
      this.modal = true;
      const itemIndex = {
        id: index,
        name: item.cultivo
      };
      this.itemModal = itemIndex;
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.folio,
        name: item.folio,
        index: index
      };
      this.itemModal = itemIndex;
    },
    toggleLote() {
      this.isLoteActive = !this.isLoteActive;
      this.color1 = this.isLoteActive ? "primary" : "secondary";
      this.color2 = this.isLoteActive ? "secondary" : "primary";
      this.isLoteActive
        ? ((this.cultivo = null), (this.ubicacion = null))
        : (this.lote = null);
      this.filterLotes();
    },

    filterLotes() {
      if (this.isCreated) {
        this.actualizarInfo();
      }
    },
    cancelDocto(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customDocumentoCancelHTTP", {
          schema: "solicitudes_empaques",
          folio: id
        })
        .then(res => {
          console.log(res.data);
          // const index = this.items.findIndex(item => item.folio == id);
          // this.items[index].estado = "cancelado";
          this.actualizarInfo();
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          this.cancelModal = false;
        });
    },
    actualizarInfo(){
      if (this.ubicacionRaiz == "") {
        this.items = []
        return
      }

      this.isLoading = true;

      let template = {
        schema: "solicitudes_empaques",
        limit: 50,
        page: this.page,
        filter: {
          wherein: [{
            field: "doc_solicitudes_empaques.payload->encabezado->ubicacion_raiz_id",
            value: [this.ubicacionRaiz]
          }],
          where: [
            {
              field: "doc_solicitudes_empaques.payload->encabezado->fechahora",
              operator: ">=",
              value: moment(this.selectedDate.start).format("YYYY-MM-DD 00:00:00")
            },
            {
              field: "doc_solicitudes_empaques.payload->encabezado->fechahora",
              operator: "<=",
              value: moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59")
            }
          ]
        },
        ["with-storage"]: ["*"]
      };

      this.actualSort != "" ? (template = {
        ...template,
        order: [{
          field: this.actualSort,
          direction: this.sorting
        }]
      }) : null

      this.actualSortJoin != "" ? (template = {
        ...template,
        orderByJoin: [{
          field: this.actualSortJoin,
          direction: this.sortingJoin
        }]
      }) : null

      this.filter != "" ? (template = {
        ...template, filter: {
          ...template.filter,
          and: {
            orWhere: [
              {
                field: "doc_solicitudes_empaques.folio",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "doc_solicitudes_empaques.payload->encabezado->cultivo",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              {
                field: "doc_solicitudes_empaques.payload->encabezado->solicitante",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ...this.mostrarColumnaAutor?[
              {
                field: "doc_solicitudes_empaques.author->correo",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              },
              ]:[]
            ],
            orWhereJoin:[
              {
                field: "ubicacion.payload->nombre",
                operator: "like",
                value: `%${this.filter}%`,
                collate: "utf8mb4_unicode_ci"
              }
            ]
          }
        }
      }) : null;
      
      !this.showCancel ? (template = {
        ...template, filter: {
          ...template.filter,
          where: [
            ...template.filter.where,
            {
              field: "doc_solicitudes_empaques.estado",
              operator: "!=",
              value: "cancelado"
            }
          ]
        }
      }) : null;


      const documento = [this.$store.dispatch("customDocumentoHTTP", template)]
      if (!this.isCreated || this.cambioUbicacionRaiz) {
        this.cambioUbicacionRaiz = false
      }

      Promise.all(documento)
        .then(([documentos]) => {
          
          this.items = documentos.data;
          
          this.pages = documentos?.paginate?.last_page;
          this.page = documentos?.paginate?.current_page;
          
          this.isCreated = true;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));


    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  width: 100%;
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.padding-left-custom {
  padding-right: 5rem;
}
.custom-width-input {
  width: 100%;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
